import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Button, Ripple } from "arv-reactcomponents";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

@inject("SearchBarStore", "CommonStore")
@observer
class Search extends Component {
  static trackToggleSearch(isDesktop) {
    Analytics.trackEvent({
      action: Event.action.SEARCH_CLICK,
      label: Event.label.getSource(window.pageType),
      category: isDesktop
        ? Event.category.TOP_MENU_NAVIGATION
        : Event.category.MOBILE_TOPNAV,
    });
  }

  constructor(props) {
    super(props);

    this.toggleSearch = this.toggleSearch.bind(this);
  }

  toggleSearch() {
    const { isDesktop } = this.props.CommonStore;

    this.props.SearchBarStore.toggleSearch();
    Search.trackToggleSearch(isDesktop);
  }

  render() {
    const { className, text } = this.props;

    return (
      <Ripple className="nwc-ripple-light">
        <Button
          className={`
            nwc-btn-primary-txt
            nw-actionbuttons-btn
            nw-actionbuttons-search
            ${className}
          `}
          onClick={this.toggleSearch}
        >
          <i className="icomoon-search3" />
          <span className="nw-actionbuttons-text">{text}</span>
        </Button>
      </Ripple>
    );
  }
}

Search.wrappedComponent.defaultProps = {
  className: "",
  text: "",
};

Search.wrappedComponent.propTypes = {
  SearchBarStore: PropTypes.shape({
    toggleSearch: PropTypes.func,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

const getFinalComponent = component =>
  inject("SearchBarStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Search.wrappedComponent,
  component: Search,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/ActionButtons/Search/index.js